<template>
    <header class="d-flex justify-content-between align-items-center">
      <h1>{{ title }}</h1>
      <div class="header-buttons">
        <slot name="buttons"></slot>
      </div>
    </header>
  </template>
  
  <script>
  export default {
    name: 'AppHeader',
    props: {
      title: {
        type: String,
        required: true
      }
    }
  };
  </script>
  
  <style scoped>
  /* ux-operativa-v2-spec.md RF-4: el título del módulo orienta, no ocupa la
     pantalla. Sin esto el h1 tomaba el 2,5 rem de Bootstrap. */
  header {
    gap: 0.75rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  h1 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    line-height: 1.3;
  }

  @media (max-width: 991.98px) {
    h1 {
      font-size: 1.1rem;
    }
  }
  </style>
  